/* eslint-disable @typescript-eslint/dot-notation */
import { Component, ViewEncapsulation } from '@angular/core';
import { ICellEditorParams } from 'ag-grid-community';
import { ICellEditorAngularComp } from 'ag-grid-angular';


@Component({
    selector: 'se-autocomplete-cell-editor',
    templateUrl: './autocomplete-cell-editor.component.html',
    styleUrls: ['./autocomplete-cell-editor.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AutocompleteCellEditorComponent implements ICellEditorAngularComp {

    public items: string[];
    public required: boolean;

    value: string;
    params: ICellEditorParams;
    cellWidth: string;

    agInit(params: ICellEditorParams): void {
        this.params = params;
        this.value = params.value;
        this.cellWidth = params.column.getActualWidth() + 'px';
        this.configCellEditor();
    }

    getValue(): any {
        return this.value;
    }

    isCancelBeforeStart(): boolean {
        return false;
    }

    isPopup(): boolean {
        return true;
    }

    private configCellEditor() {
        this.required = this.params['required'];

        if (this.isFunction(this.params['dataSource'])) {
            this.items = this.params['dataSource']();
        } else {
            this.items = this.params['dataSource'] || [];
        }
    }

    setValue(newVal: string) {
        this.value = newVal;
    }

    private isFunction(functionToCheck: any) {
        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
    }
}
